import { render, staticRenderFns } from "./doc_viewer_docs.vue?vue&type=template&id=385d45d3&scoped=true"
import script from "./doc_viewer_docs.vue?vue&type=script&lang=js"
export * from "./doc_viewer_docs.vue?vue&type=script&lang=js"
import style0 from "./doc_viewer_docs.vue?vue&type=style&index=0&id=385d45d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d45d3",
  null
  
)

export default component.exports